<template>
  <editor
    v-model="content"
    @onChange="onChange"
    @onBlur="onBlur"
    :init="initEditor"
    toolbar="insert | undo redo | formatselect | bold italic forecolor backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat | code preview fullscreen"
  ></editor>
</template>

<script>
import Editor from '@tinymce/tinymce-vue';

export default {
  name: 'BKEditor',
  components: {
    Editor
  },
  data() {
    return {
      content: '',
      initEditor: {
        menubar: false,
        branding: false,
        language: 'zh_CN',
        relative_urls: false,
        // document_base_url: 'https://www.fbsex.co/path1/,'
        plugins:
          'table code print preview fullpage powerpaste casechange importcss tinydrive searchreplace autolink autosave save directionality advcode visualblocks visualchars fullscreen image link media mediaembed template codesample table charmap hr pagebreak nonbreaking anchor toc insertdatetime advlist lists checklist wordcount tinymcespellchecker a11ychecker imagetools textpattern noneditable help formatpainter permanentpen pageembed charmap tinycomments mentions quickbars linkchecker emoticons',
        images_upload_handler: (blobInfo, success, failure) => {
          this.$axios
            .post({
              url: '/la/admin/upload',
              dataType: 'file',
              data: blobInfo.blob()
            })
            .then(({ data }) => {
              success(data);
            })
            .catch(() => {
              failure('上传错误！');
            });
        }
      }
    };
  },
  props: ['value'],
  watch: {
    value(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.content = newVal || '';
      }
    }
  },
  methods: {
    onChange(evt) {
      const editor = evt.target;
      const content = editor.getContent();

      this.$emit('input', content);
      this.$emit('change', content);
      this.$parent.$emit('el.form.change', content);
    },
    onBlur(evt) {
      const editor = evt.target;
      const content = editor.getContent();

      this.$emit('input', content);
      this.$emit('change', content);
      this.$parent.$emit('el.form.blur', content);
    }
  },
  mounted() {
    this.content = this.value;
  }
};
</script>
